module.exports = __webpack_public_path__ + "img/greensuitman1.432eb0e4.jpg";